<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div class="titlePart">成效统计</div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="平台需求统计" name="first">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="统计年份">
              <el-date-picker
                :picker-options="pickerOptions"
                v-model="searchForm.year"
                type="year"
                placeholder="选择年"
                @change="handleYearChange"
                format="yyyy 年"
                value-format="yyyy"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="统计月份">
              <el-date-picker
                v-model="searchForm.month"
                :picker-options="pickerMonth"
                type="month"
                placeholder="选择月"
                @change="handleMonthChange"
                format="MM 月"
                value-format="M"
                popper-class="myMonth"
                :disabled="!searchForm.year"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label style="float: right">
              <el-button
                type="primary"
                class="myPrimaryButton"
                icon="el-icon-upload2"
                @click="handleExport"
              >导出报表</el-button>
            </el-form-item>
          </el-form>
          <div class="showListchexiao">
            <img src="../../assets/images/leiji.png" alt />
            <div class="list">
              <div class="item">
                <img src="../../assets/images/fabuxuqiuqiye.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.financingNeedsEnterpriseNum==0?0:formatNumber3(queryInfo.financingNeedsEnterpriseNum) }}</div>
                  <div class="bottom">发布需求企业（家）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/fabuxuqiu.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.financingNeedsNum==0?0:formatNumber3(queryInfo.financingNeedsNum) }}</div>
                  <div class="bottom">发布需求（条）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/fabuxuqiujine.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.financingNeedsAmount==0?0:formatNumber3(queryInfo.financingNeedsAmount) }}</div>
                  <div class="bottom">发布需求金额（亿元）</div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="平台融资统计" name="second">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="统计年份">
              <el-date-picker
                :picker-options="pickerOptions"
                v-model="searchForm.year"
                type="year"
                placeholder="选择年"
                @change="handleYearChange"
                format="yyyy 年"
                value-format="yyyy"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="统计月份">
              <el-date-picker
                :picker-options="pickerMonth"
                v-model="searchForm.month"
                type="month"
                placeholder="选择月"
                @change="handleMonthChange"
                format="MM 月"
                value-format="M"
                popper-class="myMonth"
                :disabled="!searchForm.year"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label style="float: right">
              <el-button
                type="primary"
                class="myPrimaryButton"
                icon="el-icon-upload2"
                @click="handlePlatformExport"
              >导出报表</el-button>
            </el-form-item>
          </el-form>
          <div class="showListshuoxin">
            <img src="../../assets/images/leiji.png" alt />
            <div class="list">
              <div class="item">
                <img src="../../assets/images/shouxinhushu.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.creditEnterpriseNum==0?0:formatNumber3(queryInfo.creditEnterpriseNum) }}</div>
                  <div class="bottom">授信户数（家）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/shouxinjine.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.creditAmount==0?0:formatNumber3(queryInfo.creditAmount) }}</div>
                  <div class="bottom">授信金额（亿元）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/fangkuanhushu.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.loanEnterpriseNum==0?0:formatNumber3(queryInfo.loanEnterpriseNum) }}</div>
                  <div class="bottom">放款户数（家）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/fangkuanjine.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.loanAmount==0?0:formatNumber3(queryInfo.loanAmount) }}</div>
                  <div class="bottom">放款金额（亿元）</div>
                </div>
              </div>
            </div>
            <!-- <img src="../../assets/images/quxian.png" alt /> -->
          </div>
          <!-- <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="area" label="平台" width="200"></el-table-column>
            <el-table-column prop="creditEnterpriseNum" label="授信户数（家）" :formatter="formatNumber2"></el-table-column>
            <el-table-column prop="creditAmount" label="授信金额（亿元）" :formatter="formatNumber2"></el-table-column>
            <el-table-column prop="loanEnterpriseNum" label="放款户数（家）" :formatter="formatNumber2"></el-table-column>
            <el-table-column prop="loanAmount" label="放款金额（亿元）" :formatter="formatNumber2"></el-table-column>
          </el-table>-->
        </el-tab-pane>
        <el-tab-pane label="企业推荐情况统计" name="third" v-if="getDeptId == '5'">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="统计年份">
              <el-date-picker
                v-model="searchForm.year"
                :picker-options="pickerOptions"
                type="year"
                placeholder="选择年"
                @change="handleYearChange"
                format="yyyy 年"
                value-format="yyyy"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="统计月份">
              <el-date-picker
                v-model="searchForm.month"
                :picker-options="pickerMonth"
                type="month"
                placeholder="选择月"
                @change="handleMonthChange"
                format="MM 月"
                value-format="M"
                popper-class="myMonth"
                :disabled="!searchForm.year"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label style="float: right">
              <el-button
                type="primary"
                class="myPrimaryButton"
                icon="el-icon-upload2"
                @click="handleEnterpriseExport"
              >导出报表</el-button>
            </el-form-item>
          </el-form>
          <div class="showList showList2">
            <img src="../../assets/images/leiji.png" alt />
            <div class="list">
              <div class="item">
                <img src="../../assets/images/tuijianqiye.png" alt />
                <div class="right">
                  <div class="top">{{queryInfo.reCount==0?0:formatNumber3(queryInfo.reCount) }}</div>
                  <div class="bottom">推荐企业（户）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/yiguanzhu.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.followCount == 0?0:formatNumber3(queryInfo.followCount) }}</div>
                  <div class="bottom">已关注（户）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/shouxinhushu.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.creditCount.cou==0?0:formatNumber3(queryInfo.creditCount.cou) }}</div>
                  <div class="bottom">已授信（户）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/shouxinjine.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.creditCount.creditAmount==0?0:formatNumber3(queryInfo.creditCount.creditAmount) }}</div>
                  <div class="bottom">授信金额（万元）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/fangkuanhushu.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.loanCount.cou==0?0:formatNumber3(queryInfo.loanCount.cou) }}</div>
                  <div class="bottom">已放款（户）</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/fangkuanjine.png" alt />
                <div class="right">
                  <div
                    class="top"
                  >{{ queryInfo.loanCount.loanAmount==0?0:formatNumber3(queryInfo.loanCount.loanAmount) }}</div>
                  <div class="bottom">放款金额（万元）</div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="无贷/有贷企业" name="four" v-if="getDeptId == '5'">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="统计年份">
              <el-date-picker
                :picker-options="pickerOptions"
                v-model="searchForm.year"
                type="year"
                placeholder="选择年"
                @change="handleYearChange"
                format="yyyy 年"
                value-format="yyyy"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="统计月份">
              <el-date-picker
                v-model="searchForm.month"
                :picker-options="pickerMonth"
                type="month"
                placeholder="选择月"
                @change="handleMonthChange"
                format="MM 月"
                value-format="M"
                popper-class="myMonth"
                :disabled="!searchForm.year"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label style="float: right">
              <el-button
                type="primary"
                class="myPrimaryButton"
                icon="el-icon-upload2"
                @click="youdaihandleExport"
              >导出报表</el-button>
            </el-form-item>
          </el-form>
          <div class="showListchexiao">
            <img src="../../assets/images/leiji.png" alt />
            <div class="list">
              <div class="item">
                <img src="../../assets/images/rk.png" alt />
                <div class="right">
                  <div class="top">
                    {{ queryInfo.totalCompanyCount ==0?0:formatNumber3(queryInfo.totalCompanyCount) }}万户
                    <!-- 66.6万户 -->
                  </div>
                  <div class="bottom">总入库企业数量</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/yd.png" alt />
                <div class="right">
                  <div class="top">
                    {{ queryInfo.loanCompanyCount==0?0:formatNumber3(queryInfo.loanCompanyCount) }}万户
                    <!-- 6.6万户 -->
                  </div>
                  <div class="bottom">有贷企业数量</div>
                </div>
              </div>
              <div class="item">
                <img src="../../assets/images/wd.png" alt />
                <div class="right">
                  <div class="top">
                    {{queryInfo.notloanCompanyCount==0? 0: formatNumber3(queryInfo.notloanCompanyCount)}}万户
                    <!-- 60万户 -->
                  </div>
                  <div class="bottom">无贷企业数量</div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TopMessage from "@/components/TopMessage";
import {
  queryXQStatistics,
  queryRZStatistics,
  financeEffect,
  loanAndNoLoanAmount
} from "@/api/statistics";
const temp = {
  financingNeedsAmount: 0,
  financingNeedsEnterpriseNum: 0,
  financingNeedsNum: 0,
  creditAmount: 0,
  creditEnterpriseNum: 0,
  loanAmount: 0,
  loanEnterpriseNum: 0,
  reCount: 0,
  followCount: 0,
  creditCount: {
    cou: 0,
    creditAmount: 0
  },
  loanCount: {
    cou: 0,
    loanAmount: 0
  },
  loanCompanyCount: 0,
  notloanCompanyCount: 0,
  totalCompanyCount: 0
};
export default {
  components: { TopMessage },
  data() {
    return {
      activeName: "first",
      searchForm: {
        year: "",
        month: ""
      },
      queryInfo: Object.assign({}, temp),
      tableData: [],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now(); // 选当前时间之前的时间
        }
      },
      pickerMonth: {
        disabledDate: time => {
          let year = this.searchForm.year;
          let date = new Date().getFullYear();
          if (date > year) {
            return time.getTime() < Date.now();
          } else if (date == year) {
            return time.getTime() > Date.now();
          }
        }
      }
    };
  },
  computed: {
    getDeptId: function() {
      return sessionStorage.getItem("deptId");
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.activeName === "first") {
        queryXQStatistics(this.sendParam(this.searchForm))
          .then(res => {
            res = this.paramDecrypt(res);
            if (res.code === 200) {
              console.log(res, "this.queryInfo");
              if (res.data) {
                this.queryInfo = Object.assign(this.queryInfo, res.data);
              } else {
                this.queryInfo = Object.assign({}, temp);
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      } else if (this.activeName === "second") {
        queryRZStatistics(this.sendParam(this.searchForm))
          .then(res => {
            res = this.paramDecrypt(res);
            console.log(res);
            if (res.code === 200) {
              if (res.data.resultCount) {
                this.queryInfo = Object.assign(
                  this.queryInfo,
                  res.data.resultCount
                );
              } else {
                this.queryInfo = Object.assign({}, temp);
              }
              this.tableData = res.data.resultList;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      } else if (this.activeName === "third") {
        financeEffect(this.sendParam(this.searchForm))
          .then(res => {
            res = this.paramDecrypt(res);
            if (res.code === 200) {
              if (res.data) {
                this.queryInfo = Object.assign(this.queryInfo, res.data);
              } else {
                this.queryInfo = Object.assign({}, temp);
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      } else if (this.activeName === "four") {
        loanAndNoLoanAmount(this.sendParam(this.searchForm))
          .then(res => {
            res = this.paramDecrypt(res);
            if (res.code === 200) {
              if (res.data) {
                this.queryInfo = Object.assign(this.queryInfo, res.data);
              } else {
                this.queryInfo = Object.assign({}, temp);
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      }
    },
    handleClick() {
      this.searchForm = {
        year: "",
        month: ""
      };
      this.getList();
    },
    youdaihandleExport() {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "post",
        this.baseUrl + "/api/credit/financial/loanAndNoLoanAmountExport",
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷综合服务平台成效统计.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(
        "year=" + this.searchForm.year + "&month=" + this.searchForm.month
      );
    },
    handleYearChange(v) {
      if (!v) this.searchForm.month = "";
      this.getList();
    },
    handleMonthChange() {
      this.getList();
    },
    // 格式化数字
    // formatNumber(num,count) {
    //   if (!count) count = 0;
    //   let result = "";
    //   num = (num.toString().split(".")[0] || 0).toString();
    //   if (num.length > 8 - count) num = num.slice(0, num.length - 8 + count);
    //   while (num.length > 3) {
    //     result = ',' + num.slice(-3) + result;
    //     num = num.slice(0, num.length - 3);
    //   }
    //   if (num) { result = num + result; }
    //   return result;
    // },
    formatNumber2(row, column, val) {
      return this.formatNumber3(val);
    },
    formatNumber3(num) {
      let result = "";
      // num = (num.toString().split(".")[0] || 0).toString();
      // num = num.toString()
      while (num.length > 3) {
        result = "," + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      return result;
    },
    // 是否显示亿+
    // isShow(num, count) {
    //   if (!count) count = 0;
    //   return num.toString().split(".")[0].length > 8 - count;
    // },
    // 导出
    handlePlatformExport() {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "post",
        this.baseUrl + "/api/credit/financial/creditByParamExport",
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "平台融资导出统计.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(
        "year=" + this.searchForm.year + "&month=" + this.searchForm.month
      );
    },
    //企业推荐导出
    handleEnterpriseExport() {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "post",
        this.baseUrl + "/api/loan/apply/financeEffectExport   ",
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "企业推荐导出统计.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(
        "year=" + this.searchForm.year + "&month=" + this.searchForm.month
      );
    },
    handleExport() {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "post",
        this.baseUrl + "/api/credit/excel/expertEffectExcel",
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷综合服务平台成效统计.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(
        "year=" + this.searchForm.year + "&month=" + this.searchForm.month
      );
    }
  }
};
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  min-height: 740px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 0;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
  }
  /deep/.el-tabs {
    margin-top: 10px;
    .el-tabs__header {
      background: #f3f4f9;
      padding: 0 30px;
      .el-tabs__nav-wrap::after {
        content: unset;
      }
    }
    .el-tabs__content {
      padding: 10px 30px;
    }
  }
  /deep/.el-table thead tr th {
    background: #f3f4f9;
  }
}
/deep/.el-form {
  padding: 20px 30px 0;
  .el-date-editor {
    width: 200px;
  }
}
.showList {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  img {
    height: 32px;
  }
  .list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 20px 0;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 60px;
        height: 60px;
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 5px;
        .top {
          font-weight: 550;
          font-size: 26px;
          span {
            font-size: 18px;
            color: #252525;
            font-weight: normal;
            display: inline-block;
            margin-left: 4px;
          }
        }
        .bottom {
          font-size: 16px;
        }
      }
    }
  }
}
.showListshuoxin {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  img {
    height: 32px;
  }
  .list {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    margin: 50px 0;
    min-height: 60px;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 60px;
        height: 60px;
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 5px;
        .top {
          font-weight: 550;
          font-size: 26px;
          span {
            font-size: 18px;
            color: #252525;
            font-weight: normal;
            display: inline-block;
            margin-left: 4px;
          }
        }
        .bottom {
          font-size: 16px;
        }
      }
    }
  }
}
.showListchexiao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  img {
    height: 32px;
  }
  .list {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    margin: 50px 0;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 60px;
        height: 60px;
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 5px;
        .top {
          font-weight: 550;
          font-size: 26px;
          span {
            font-size: 18px;
            color: #252525;
            font-weight: normal;
            display: inline-block;
            margin-left: 4px;
          }
        }
        .bottom {
          font-size: 16px;
        }
      }
    }
  }
}
.showList2 {
  .list {
    margin-top: 34px;
    margin-bottom: 0;
    width: 580px;
    display: flex;
    //align-content: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-right: -80px;
    .item {
      margin-bottom: 76px;
      margin-right: 80px;
      .bottom {
        min-width: 130px;
      }
    }
  }
}
</style>
<style lang="less">
.myMonth {
  .el-date-picker__header {
    display: none;
  }
}
</style>
